module.exports = __webpack_public_path__ + "static/17-e25bb5326d9ab819f342239f8ded7268.webp";